module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_1_2-269757c16499b2757a92a8d5895ecab7.webp";